<template>
  <div class="mx-0 my-0 px-0 py-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />

    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Frequently asked questions</h1>
      </div>

      <div class="row">
        <div class="col-3 me-2 ms-2 faq-nav">
          <ul class="nav nav-pills flex-column w-100" role="tablist">
            <li class="nav-item" v-if="topfaqs.length > 0">
              <button
                class="nav-link text-start w-100 rounded-0"
                :class="{ active: activeTab === 'most-read' }"
                @click="activeTab = 'most-read'"
                type="button"
              >
                <fa-icon :icon="['far', 'star']" class="me-2" />Most read
              </button>
            </li>
            <li class="nav-item" v-for="(thefaqs, cat) in groupedfaqs" :key="cat">
              <button
                class="nav-link text-start w-100 rounded-0"
                :class="{ active: activeTab === cat }"
                @click="activeTab = cat"
                type="button"
              >
                {{ gettitle(cat) }}
              </button>
            </li>
          </ul>
        </div>
        <div class="col faq-content ps-0">
          <div class="card border-0">
            <div class="card-body">
              <div id="faq-accordion">
                <!-- Most Read Tab -->
                <div v-if="topfaqs.length > 0 && activeTab === 'most-read'" class="pt-0 mt-0 accordion" role="tablist">
                  <div
                    v-for="(faq, idx) in topfaqs"
                    :key="faq.id"
                    class="mb-0 border-0 px-0 faq-item"
                  >
                    <div class="p-0 border-0 bg-white">
                      <button
                        class="btn btn-info text-start w-100 px-0 rounded-0"
                        :class="{ collapsed: openFaqId !== faq.id }"
                        type="button"
                        :aria-expanded="openFaqId === faq.id"
                        :aria-controls="'collapse-' + faq.id"
                        @click="toggleFaq(faq.id)"
                      >
                        <div class="d-flex w-100 align-items-center justify-content-between">
                          <span class="faq-heading-text">{{ faq.faq_heading }}</span>
                          <span class="faq-chevron">
                            <fa-icon icon="chevron-down" class="when-closed" />
                            <fa-icon icon="chevron-up" class="when-opened" />
                          </span>
                        </div>
                      </button>
                    </div>
                    <div
                      :id="'collapse-' + faq.id"
                      class="collapse col-12"
                      :class="{ show: openFaqId === faq.id }"
                    >
                      <div class="border-0 card-body">
                        <span style="font-weight: 200;" v-html="faq.faq_text" />
                      </div>
                    </div>
                    <hr v-if="idx !== topfaqs.length - 1" class="faq-divider">
                  </div>
                </div>

                <!-- Category Tabs -->
                <div
                  v-for="(thefaqs, cat) in groupedfaqs"
                  :key="cat"
                  v-show="activeTab === cat"
                  class="pt-0 mt-0 accordion"
                  role="tablist"
                >
                  <div
                    v-for="(faq, idx) in thefaqs"
                    :key="faq.id"
                    class="mb-0 border-0 px-0 faq-item"
                  >
                    <div class="p-0 border-0 bg-white">
                      <button
                        class="btn btn-info text-start w-100 px-0 rounded-0"
                        :class="{ collapsed: openFaqId !== faq.id }"
                        type="button"
                        :aria-expanded="openFaqId === faq.id"
                        :aria-controls="'collapse-' + faq.id"
                        @click="toggleFaq(faq.id)"
                      >
                        <div class="d-flex w-100 align-items-center justify-content-between">
                          <span class="faq-heading-text">{{ faq.faq_heading }}</span>
                          <span class="faq-chevron">
                            <fa-icon icon="chevron-down" class="when-closed" />
                            <fa-icon icon="chevron-up" class="when-opened" />
                          </span>
                        </div>
                      </button>
                    </div>
                    <div
                      :id="'collapse-' + faq.id"
                      class="collapse col-12"
                      :class="{ show: openFaqId === faq.id }"
                    >
                      <div class="border-0 card-body">
                        <span style="font-weight: 200;" v-html="faq.faq_text" />
                      </div>
                    </div>
                    <hr v-if="idx !== thefaqs.length - 1" class="faq-divider">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from './Breadcrumb.vue'
import Navbar from './Navbar.vue'

function groupByKey (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export default {
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      faqcategories: [],
      groupedfaqs: [],
      topfaqs: [],
      counts: [],
      opentab: 0,
      activeTab: 'most-read',
      openFaqId: null
    }
  },
  created () {
    this.faqs_get()
  },
  watch: {
    activeTab () {
      this.openFaqId = null
    }
  },
  methods: {
    gettitle (cat) {
      const fcat =
        this.faqcategories.filter(f => f.sequence_number === cat).length
          ? this.faqcategories.filter(f => f.sequence_number === cat)[0].faqcategory_name
          : '- No category -'
      return fcat
    },
    faqs_get () {
      this.$store.dispatch('records_readall', { table_name: 'g_faqcategories ' })
        .then((resp) => {
          this.faqcategories = resp.data.result
          this.$store.dispatch('record_readlist', { table_name: 'g_faq', orderby: 'sequence_number' })
            .then((resp) => {
              const faqs = resp.data.result.map(
                (r) => {
                  return {
                    ...r,
                    faqcategory_id: r.faqcategory_id ? r.faqcategory_id : '- No category -',
                    faqcategory_sequence:
                        this.faqcategories.filter(f => f.faqcategory_name === r.faqcategory_id).length
                          ? this.faqcategories.filter(f => f.faqcategory_name === r.faqcategory_id)[0].sequence_number
                          : 0
                  }
                })
              const topfaqs = faqs.filter(f => f.number_reads > 0)
              topfaqs.sort((a, b) => (a.number_reads < b.number_reads) ? 1 : -1)
              this.topfaqs = topfaqs.slice(0, 10)
              const groupedfaqs = groupByKey(faqs, 'faqcategory_sequence')
              const sortedfaqs = Object.keys(groupedfaqs).sort().reduce(
                (obj, key) => {
                  obj[key] = groupedfaqs[key]
                  return obj
                },
                {}
              )
              this.groupedfaqs = sortedfaqs
              if (this.topfaqs.length === 0 && Object.keys(sortedfaqs).length > 0) {
                this.activeTab = Object.keys(sortedfaqs)[0]
              }
            })
        })
    },
    toggleFaq (faqId) {
      if (this.openFaqId === faqId) {
        this.openFaqId = null
      } else {
        this.openFaqId = faqId
        this.addcount(faqId)
      }
    },
    addcount (faq_id) {
      if (!this.counts[faq_id]) {
        this.counts[faq_id] = 1
        this.$store.dispatch('record_read', { table_name: 'g_faq', id: faq_id })
          .then((resp) => {
            const number_reads = resp.data.number_reads + 1
            this.savefield('g_faq', faq_id, 'number_reads', number_reads)
          })
      }
    },
    savefield (tablename, id, fieldname, value) {
      if (id > 0) {
        const record = {
          id,
          [fieldname]: value
        }
        this.$store.dispatch('field_save', { tablename, record })
      }
    }
  }
}
</script>
<style scoped>
/* OLD CSS */
/*.btn-info {
    border: none !important;
    background: #007d8f !important;
    color: white;
    margin: 0 !important;
}*/
/* .btn-info:focus {
  border-color: white !important;
  border: none !important;
  outline: none !important;
} */
.show {
  transition: width 0.5s, height 0.5s, transform 0.5s;
}
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
    display: none;
}
.collapsed .when-opened {
  display: none;
}
:not(.collapsed) .when-closed {
  display: none;
}
.fade-in-text {
  animation: fadeIn 1s;
}
@keyframes fadeIn {
  0% { opacity: 1; }
  100% { opacity: 1; }
}

.faq-item {
  margin-bottom: 0;
  padding-bottom: 0.25rem;
}

.faq-nav {
  background: #f8f9fa;
  padding: 1rem;
}

.faq-content {
  padding-left: 0;
  padding-right: 0;
}

.card-body {
  padding: 0;
}

.faq-item .btn-info {
  border: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.faq-item .card-body {
  padding: 1rem 1.25rem;
}

.faq-divider {
  margin: 0;
  border: 0;
  border-top: 1px solid #000;
}

.faq-heading-text {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 1.4;
  display: block;
}

.faq-chevron {
  display: inline-flex;
  align-items: center;
  color: inherit;
}

.faq-chevron .when-closed {
  display: inline-flex;
}

.faq-chevron .when-opened {
  display: none;
}

.faq-item .btn-info:not(.collapsed) .faq-chevron .when-closed {
  display: none;
}

.faq-item .btn-info:not(.collapsed) .faq-chevron .when-opened {
  display: inline-flex;
}
.collapsing {
    -webkit-transition: none;
    transition: none;
    visibility: hidden;
}

.collapse.show {
    -webkit-transition: none;
    transition: none;
    visibility: visible;
}
</style>
